import axios from 'axios';
import querystring from 'qs';
import summarybar from './summarybar.vue';
import moment from 'moment';
import addsupervisior from './addsupervisior.vue';
import supervisoralert from './supervisioralert.vue';
import addactivity from '../../app/components/activity.vue';
import draggable from "vuedraggable";
export default {
    name: 'ActivityBar',
    props: {
        date: {
            type: Date,
        },
    },
    components: {
        summarybar,
        draggable
    },
    computed: {
        doubleattendant() {
            return this.result.activties.filter(x => x.isDouble == true).length;
        }
    },
    data() {
        return {
            initialized: false,
            result: null,
            overridies: []
        };
    },
    watch: {
        templateType() {
            this.setEndDate();
        },
        page() {
            this.fetch();
        },
        date() {
            this.fetch();
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            //console.log(this.date)
            this.initialized = false;
            const params = {
                date: this.date,
            };
            let url = APIURL + '/activity/by-date?' + querystring.stringify(params);
            let response = axios.get(url, params)
                .then(resp => {
                    this.result = resp.data;
                    //this.result.activties = this.result.activties.filter(x => x.id == 41409 || x.id == 40911) //
                });
            let overrideurl = APIURL + '/activity/overridies?' + querystring.stringify(params);
            let responseOverride = axios.get(overrideurl, params)
                .then(resp => {
                    this.overridies = resp.data;
                    //this.result.activties = this.result.activties.filter(x => x.id == 41409 || x.id == 40911) //
                });
            Promise.all([response, responseOverride])
                .then(() => {
                    this.initialized = true;
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        getDate(newdate) {
            //let newdate=moment(this.date).format('YYYY-MM-DD');

            return moment.utc(newdate).format('ddd HH:mm');
        },
        addsupervisor(item) {
            let self = this;
            //console.log(this.$t('title.newactivity'))
            this.$vuedals.open({
                title: this.$t('title.addsupervisor') + item.title,
                props: {
                    item: item,
                },
                component: addsupervisior,
                size: 'lg',
                escapable: true,
                onClose(resp) {
                    self.Add(resp);
                }
            });
        },
        Add(resp) {
            let url = APIURL + '/activity/' + resp.activityId + '/registerattendant';
            let activityPeriodAttendantMaps = [];
            if (resp.activityPeriodId > 0) {
                activityPeriodAttendantMaps.push({ activityPeriodId: resp.activityPeriodId, attendantId: resp.attendantId, isApproved: true })
            }
            let saveData = [{
                id: resp.attendantId,
                isGroup: false,
                isApproved: true,
                activityPeriodAttendantMaps: activityPeriodAttendantMaps
            }];
            axios.put(url, saveData)
                .then(resp2 => {
                    this.fetch();
                });
        },
        deleteAttendant(attendantId, periodId, activityId) {
            this.$dialog.confirm(this.$t('confirm.delete'))
                .then(() => {
                    let url = APIURL + '/activity/deleteattendant/' + activityId;
                    let deletedata = {
                        activityPeriodId: periodId,
                        applicationUserId: attendantId
                    };
                    axios.post(url, deletedata)
                        .then(resp => {
                            this.fetch();
                        });
                })
                .catch(() => { });

        },
        isDoubleUser(item, isperiod) {

            const targetStart = moment.utc(item.startTime).valueOf();
            const targetEnd = moment.utc(item.endTime).valueOf();
            const targetUserIds = new Set(item.attendants.map(u => u.id));

            const hasConflict = this.result.activties.some(event => {
                // Skip comparing against itself when editing an existing event

                if (event.id === item.id && !isperiod) return false;

                if (event.id != item.id && event.activityPeriods.length == 0) {
                    const eventStart = moment.utc(event.startTime).valueOf();
                    const eventEnd = moment.utc(event.endTime).valueOf();

                    // Skip if timing is exactly the same as target
                    if (eventStart === targetEnd || eventEnd === targetStart) return false;
                    //console.log('eventStart : ' + event.startTime + " targetEnd : " + item.endTime + " eventEnd: " + event.endTime + " targetStart :" + item.startTime);
                    // 1. Time overlap condition
                    const isTimeOverlapping = targetStart < eventEnd && eventStart < targetEnd;
                    //console.log('isTimeOverlapping : ' + isTimeOverlapping);
                    const topLevelConflict = isTimeOverlapping &&
                        (event.attendants || []).some(user => targetUserIds.has(user.id));
                    //console.log('top level : ' + topLevelConflict);
                    //console.log('toplevel ' + topLevelConflict);
                    if (topLevelConflict) return true;
                }

                // 2. User conflict check
                const periodConflict = (event.activityPeriods || []).some(period => {
                    //console.log('PeriodId : ' + item.activityPeriodId);

                    if (period.activityPeriodId === item.activityPeriodId && isperiod) return false;
                    //console.log('SubPeriod Id  : ' + period.activityPeriodId);
                    //console.log('isperiod' + isperiod);
                    //console.log('period : ' + period.activityPeriodId + ' item periodId : ' + item.activityPeriodId);
                    const subStart = new Date(period.startTime).getTime();
                    const subEnd = new Date(period.endTime).getTime();

                    // Skip if timing is exactly the same as target
                    if (subStart === targetEnd || subEnd === targetStart) return false;

                    const isSubTimeOverlapping = targetStart < subEnd && subStart < targetEnd;
                    if (!isSubTimeOverlapping) return false;

                    return (period.attendants || []).some(user => targetUserIds.has(user.id));
                });
                //console.log('periodConflict : ' + periodConflict);
                return periodConflict;
                //}
            });
            item.isDouble = hasConflict;
            //console.log(hasConflict);
            //console.log("conflict found for item : " + item.id + " PeriodId : " + item.activityPeriodId + " value : " + hasConflict)
            return hasConflict;
        },
        isDoubleAttedant(item) {
            let isDouble = item.activityPeriods.some(x => x.isDouble == true)
            item.isDouble = isDouble;
            return isDouble;
        },
        checkMove(evt, item) {

            const userId = Number(evt.item.dataset.id);
            const name = evt.item.dataset.name;
            // remove the DOM node Sortable inserted; Vue will render the real one
            // only if we approve the user below
            evt.item.parentNode.removeChild(evt.item);
            console.log(evt.item.dataset);
            console.log(item);

            let attendant = {
                id: userId,
                name: name
            };
            let url = APIURL + '/activity/attendant-activity-available';

            let requestData = {
                attendantId: userId,
                activityPeriodId: item.activityPeriodId,
                activityId: item.id,
                startDate: item.startTime,
                endDate: item.endTime
            };
            axios.post(url, requestData)
                .then(resp => {
                    let response = resp.data;
                    if (response.activities.length == 0) {
                        this.Add(requestData);
                    }
                    else {

                        this.$vuedals.open({
                            title: this.$t('title.schdulealert'),
                            props: {
                                activities: response.activities,
                                attendant: attendant,
                                item: item,
                                isRegistred: response.isRegistred
                            },
                            component: supervisoralert,
                            size: 'lg',
                            escapable: true,
                            onClose() {

                            }
                        });
                    }
                });

            //console.log(evt.draggedContext.element)
            //const user = evt.draggedContext.element;
            //const fromOutside = evt.from !== evt.to;
            //const alreadyIn = this.attendees.some((u) => u.id === user.id);
            //return !(fromOutside && alreadyIn);
        },
        onChange(evt) {
            console.log('hello')
            if (evt.added) {
                /*this.$emit("user-added", evt.added.element);*/
                console.log(evt.added.element + item.title);
            }
        },
        openactivity(id) {
            let self = this;
            this.$vuedals.open({
                title: this.$t('title.newactivity'),
                props: {
                    id: id,
                },
                component: addactivity,
                size: 'lg',
                escapable: true,
                onClose(resp) {
                    self.fetch();
                }
            });
        }
    }
};